import formatAsAsset from './formatAsAsset';

export default formatAsAsset;
export { assetAsNumber } from './formatAsAsset';
export { formatAsAssetNoSign } from './formatAsAsset';